import { render } from "./delivery.vue?vue&type=template&id=22c8f9e1&scoped=true"
import script from "./delivery.vue?vue&type=script&lang=js"
export * from "./delivery.vue?vue&type=script&lang=js"

import "./delivery.vue?vue&type=style&index=0&id=22c8f9e1&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22c8f9e1"]])

export default __exports__